import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Check if there's a saved end time in sessionStorage
    const saved = sessionStorage.getItem('countdown-end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    // Set 2 hours from now
    const endTime = Date.now() + 2 * 60 * 60 * 1000;
    sessionStorage.setItem('countdown-end', endTime.toString());
    return 2 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-40 bg-gradient-to-r from-orange-600 via-orange-500 to-amber-500 text-white py-1 px-3 text-center shadow-sm" data-id="element-30">
      <div className="flex items-center justify-center gap-2" data-id="element-31">
        <span className="text-xs font-bold uppercase tracking-wide" data-id="element-32">
          🔥 Oferta por tiempo limitado
        </span>
        <div className="flex items-center gap-0.5 font-mono text-xs font-black" data-id="element-33">
          <span className="bg-white/20 rounded px-1.5 py-px" data-id="element-34">{pad(hours)}</span>
          <span className="animate-pulse" data-id="element-35">:</span>
          <span className="bg-white/20 rounded px-1.5 py-px" data-id="element-36">
            {pad(minutes)}
          </span>
          <span className="animate-pulse" data-id="element-37">:</span>
          <span className="bg-white/20 rounded px-1.5 py-px" data-id="element-38">
            {pad(seconds)}
          </span>
        </div>
      </div>
    </div>;
}